module.exports = __webpack_public_path__ + "img/ke.91877f0b.svg";